import { Button, colors, ModalActions, ModalHeader, Stack } from '@ui-components/neo.tax';
import { SyntheticEvent } from 'react';

import { CsvLogo, CsvUploadInstructions, useCsvFileUrl } from '@neo.tax/shared';

import { EXAMPLE_DATA_STRINGIFIED, HEADERS_STRINGIFIED } from './asc-project-bulk-upload-instruction-modal.constants';
import { StyledModal } from './asc-project-bulk-upload-instruction-modal.styled';
import { useAscProjectBulkUploadInstructionModalAnalyticIds } from './hooks';

type AscProjectBulkUploadInstructionModalProps = {
  close: () => void;
  isOpen: boolean;
  loading: boolean;
  submit: () => void;
};

export const AscProjectBulkUploadInstructionModal = ({
  close,
  isOpen,
  loading,
  submit,
}: AscProjectBulkUploadInstructionModalProps): React.ReactElement => {
  const { ascProjectBulkUploadCancelBtnId, ascProjectBulkUploadUploadBtnId } =
    useAscProjectBulkUploadInstructionModalAnalyticIds();
  const templateCsvUrl = useCsvFileUrl(HEADERS_STRINGIFIED);
  const exampleCsvUrl = useCsvFileUrl(EXAMPLE_DATA_STRINGIFIED);

  const onSubmit = (e: SyntheticEvent): void => {
    e.preventDefault();
    submit();
  };

  return (
    <StyledModal isOpen={isOpen}>
      <Stack as="form" direction="column" onSubmit={onSubmit}>
        <Stack direction="column" gap={4}>
          <ModalHeader icon={<CsvLogo />} iconBgColor={colors.white} title="Upload ASC Projects CSV" />
          <Stack direction="column" gap={2}>
            <CsvUploadInstructions
              title="Add one row per ASC project you want to create."
              templateCsvUrl={templateCsvUrl}
              templateCsvName="asc-projects-csv-upload-template.csv"
              exampleCsvUrl={exampleCsvUrl}
              exampleCsvName="asc-projects-csv-upload-example.csv"
            />
          </Stack>
        </Stack>

        <ModalActions hasTopBorder={false}>
          <Button variant="white" rounded="regular" size="base" id={ascProjectBulkUploadCancelBtnId} onClick={close}>
            Cancel
          </Button>
          <Button
            disabled={loading}
            variant="primary"
            rounded="regular"
            size="base"
            type="submit"
            id={ascProjectBulkUploadUploadBtnId}
          >
            {loading ? 'Loading...' : 'Upload'}
          </Button>
        </ModalActions>
      </Stack>
    </StyledModal>
  );
};
